<template>
    <div class="b-table-sticky-header table-responsive mt-1">
        <b-table-simple
            no-border-collapse
            striped
            small
            class="mb-0"
        >
            <b-thead>
                <b-tr>
                    <b-th
                        class="text-center"
                    >
                        {{ $t('v4.Week') }}
                    </b-th>
                    <b-th
                        class="text-center"
                    >
                        {{ $t('v4.Date') }}
                    </b-th>
                    <b-th
                        v-for="(day, dayKey) in dayMaps" :key="`d-${dayKey}`"
                        class="text-right"
                    >
                        {{ $t(`v4.${day}`) }}
                    </b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(week, weekIdx) in weeks" :key="`week-${weekIdx}`">
                    <b-td class="text-center">
                        {{ __getOrdinal(week) }}
                    </b-td>
                    <b-td class="text-center text-nowrap">
                        {{ findWeekStartDate(week) }} ~
                    </b-td>
                    <b-td
                        class="text-right"
                        v-for="(value) in [1, 2, 3, 4, 5, 6, 7]"
                        :key="`cost-${value}`"
                    >
                        {{ (weeklyCostMap[week] && weeklyCostMap[week][value] && $_getDollar(weeklyCostMap[week][value].cost).replace(' ','')) || '-' }}
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
import useCommonData from '@/composables/useCommonData'
import { toRefs, computed } from '@vue/composition-api'
export default {
    props: {
        weeks: {
            type: Array,
            default: function () {
                return []
            }
        },
        data: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const { data } = toRefs(props)
        const { __getOrdinal } = useCommonData()
        const dayMaps = {
            '1': 'Mon',
            '2': 'Tue',
            '3': 'Wed',
            '4': 'Thu',
            '5': 'Fri',
            '6': 'Sat',
            '7': 'Sun'
        }

        const findWeekStartDate = (week) => {
            const findItem = data.value.find(item => item.week === week && item.day === '1')
            if (findItem) {
                return findItem.date.substring(2, 12)
            } else {
                return ''
            }
        }
        const weeklyCostMap = computed(() => {
            return data.value.reduce((accumulator, currentValue) => {
                if (!accumulator[currentValue.week]) {
                    accumulator[currentValue.week] = {}
                }
                accumulator[currentValue.week][currentValue.day] = currentValue
                return accumulator
            }, {})
        })
        return {
            findWeekStartDate,
            __getOrdinal,
            dayMaps,
            weeklyCostMap
        }
    }
}
</script>

<style>

</style>
